// extracted by mini-css-extract-plugin
export default {"modal__delete":"style_modal__delete__ASa-Y","modal__delete_btns":"style_modal__delete_btns__MJ1Bl"};